module.exports = __webpack_public_path__ + "img/jo.aa83fcdc.png";